<template>
  <div class="cv-editor-main" v-show="showSkeleton" :class="{ 'cv-editor-main-light': personInfo.theme === 'light' }">
    <!--    <div class="pack-up" v-show="currentInfo.operation && !isUnfold" @click="handleClickOnOff(true)"-->
    <!--         :style="{opacity:!isUnfold?1:0.79}">-->
    <!--      <i class="iconfont iconarrow-right-circle"></i>-->
    <!--      <p class="title">-->
    <!--        案例贴士-->
    <!--      </p>-->
    <!--    </div>-->
    <edit-nav :page-num="pages">
      <div slot="middle-nav" class="nav-middle-block">
        <div @click.stop="downloadAppDialogVisible = !downloadAppDialogVisible" style="display: flex">
          <div>
            此刻有 <span class="high-light-text">{{ userCount }}</span> 位求职者在进行求职辅导
          </div>
          <img src="https://files.wondercv.com/pc/editor/editer-bar-job-seeker.png" class="seek-icon" style="width: 24px; margin-top: -6px;">
        </div>
		<div v-if="downloadAppDialogVisible" class="download-app-content">
		<img :src="banner.image" alt="" @click="toLink" class="pages_image">
          <!-- <h1>加入APP校友群讨论</h1>
          <span class="desc">你有 264 个校友已加入超级校友群</span>
          <img src="https://files.wondercv.com/download-code/cv-editor-vue.png" alt="">
          <span class="download-app-description">扫码下载APP 获取校友内推资源</span> -->
        </div>
        <!-- <el-tooltip class="check-item" placement="bottom" popper-class="nav-tooltip-container">
          <p>此刻有 <span class="high-light-text">{{ userCount }}</span> 位求职者在「超级简历APP」陪你</p>
          <div class="download-app-content" slot="content">
            <h1>加入APP校友群讨论</h1>
           <span class="desc">你有 264 个校友已加入超级校友群</span>
            <img src="https://files.wondercv.com/download-code/cv-editor-vue.png" alt="">
            <span class="download-app-description">扫码下载APP 获取校友内推资源</span>
          </div>
        </el-tooltip> -->
      </div>
    </edit-nav>
    <!--:style="{transform: sidebarOption ? 'translateX(-348px)': 'translateX(0px)'}" -->
    <div class="edit-cv-main"
         :style="{ height: nonChrome ? 'calc(100vh - 120px)' : 'calc(100vh - 80)', paddingTop:nonChrome ? '112px' : '72px' }">
      <!-- 左侧tabbar -->
			<!-- <sidebar v-if="!isShowDownloadResume"/> -->

      <!-- sidbar内容区域 -->
      <div v-show="!isShowDownloadResume && !libraryState" class="sidebar-side-content" :class="{'sidebar-content-active': currentInfo.operation, 'job': sidebarOption === 'job'}">

        <!-- 检查 tab 内容区域 -->
        <div class="info side-info-bottom"
             :class="[{'side-bottom': !currentInfo.operation}, {'side-bottom-mentor': cvDetail.basic_info && cvDetail.basic_info.mentor_id}]"
             v-show="sidebarOption === 'check'">
          <info ref="sideBar" :sidebar-option="sidebarOption" :edit-data="editData" @dealCheckDomScroll="dealCheckDomScroll" @changeDownloadAppState="changeDownloadAppState"
                @downloadApp="changeDownloadAppResume"/>
        </div>

        <!-- 职位 tab 内容区域 -->
        <!-- <div class="job" v-show="sidebarOption === 'job'">
          <job/>
        </div> -->

        <!-- 经历库 tab 内容区域 -->
<!--        <div class="library" v-show="sidebarOption === 'library'">-->
<!--          <library/>-->
<!--        </div>-->

        <!-- 排版 tab 内容区域 -->
        <div class="composing layout-flex" v-show="sidebarOption === 'composing'">
          <composing ref="composingRef" />
        </div>

        <!-- 模块管理 tab 内容区域 -->
        <div class="manage layout-flex" v-show="sidebarOption === 'manage'">
          <manage/>
        </div>

      </div>
      <!-- 中间简历编辑  -->
      <div class="edit" :class="[{'edit-animation': currentInfo.operation}]" v-if="currentInfo.operation"
           ref="editArea">
        <edit-module ref="editModuleForm"/>
      </div>
			<!--返回框-->
      <div class="back-box" v-if="isShowDownloadResume || libraryState" @click="closeRightContent">
        <div class="back-btn">
          <i class="iconfanhui iconfont"></i>
        </div>
        <p class="back-name">返回</p>
      </div>
      <!-- 右边的预览区域 -->
<!--      <div class="cv-preview-container">-->
      <div class="cvs" :style="{transform: `scale(${ scale })`}">
        <div v-show="!isShowDownloadResume" :style="{width: resumeW + 'px'}">
          <comp-menu :stage="resumeW < 686 ? 'one' : 'second'" />
        </div>
        <div id="cvsEditorDom" class="cvs-component" @scroll="handleScroll" @mouseover="onMouseOver" @mouseleave="onMouseLeave"
             :class="{'flow-hidden': showScanner, 'download': isShowDownloadResume}">

          <div
              :class="['resume', cvDetail.format_info && cvDetail.format_info.page_size || 'a4', {'one-page-bottom': pages === 1}]"
              :style="{ height: ((cvDetail.format_info && cvDetail.format_info.page_size || 'a4') === 'a4' ? resumeWidth / (210 / 297)  : resumeWidth / (215.9 / 279.4)) + 'px'}">
            <!-- <transition name="opacity">
                <skeleton :type="3" v-show="resumeSkeleton||isResize"/>
            </transition> -->

            <resume ref="resume" class="cvs-hover" :is-page="true" :auto-page="true" :page-index="page"
                    :is-scale="true" @get-pages="getPages" @dealCheckDomScroll="dealCheckDomScroll"
                    @resumeMouseover="onMouseOver" @resumeMouseleave="onMouseLeave" @saveFormData="saveFormData" @resumeWidthFun="resumeWidthFun"/>
          </div>
          <cv-scanner v-if="showScanner"/>
        </div>
				<!-- 简历纠错模式不显示 -->
				<template v-if="!openResumeError">
					<transition name="opacity" v-if="!isShowDownloadResume">
						<div class="resume-pagination" v-show="showPagination">
							<span class="page-count">{{ currentPage }}/{{ pages }}</span>
						</div>
					</transition>
					<transition name="opacity" v-if="!isShowDownloadResume">
						<div class="resume-pagination resume-one-page" v-show="!showPagination">
							<div class="one-page-content" @click="handleClickOnePage">
								<i class="iconfont iconfile-text"/>
								<span>{{!autoOnePage ? '智能一页' : '取消一页'}}</span>
							</div>
						</div>
					</transition>
					<a v-show="resumeCommentsNum && !isShowDownloadResume" class="resume-review" :href="`/cvs/${cvEncodedToken}/share`" target="_blank">
						<i class="iconfont iconpinglun2"></i>
						<span>({{resumeCommentsNum}}条)</span>
					</a>
				</template>
      </div>

			<div
				v-if="!isShowDownloadResume && !libraryState && !openResumeError && !currentInfo.operation"
				class="replace-style-container"
			>
				<div class="replace-btn" @click="replaceStyle">
					<img
						v-if="!isFirstRound"
						:class="{ 'rotate': isRotating }"
						src="https://logo.wondercv.com/banners/OBrlx8gZWiXHMr8.png"
						alt="" 
					/>
					{{currentStyleIndex === 0 && isFirstRound ? '立即更换' : '换一换'}}
				</div>
			</div>
<!--      新的简历下载框-->
      <down-resume-box/>
<!--      </div>-->
    </div>
    <!-- 页面全局组件 -->
    <!-- <show/> -->
    <!-- 下载简历组件 -->
    <!-- <div class="download-resume">
      <resume :is-scale="false" :download="true" />
    </div> -->
    <!--    <cv-scanner></cv-scanner>-->
    <!-- <div class="change-theme" @click="changeEditorTheme">
      <transition name="icon">
        <img v-show="personInfo.theme === 'light'" src="https://files.wondercv.com/icon/sun.png" alt="">
      </transition>
      <transition name="icon">
        <img v-show="personInfo.theme === 'dark'" class="dark-theme" src="https://files.wondercv.com/icon/moon.png"
             alt="">
      </transition>
    </div>
    <div class="phone-code" @click="changeLibraryState">
		  <span class="iconfont iconshouji" />
      <div class="library-box" :class="libraryState ? 'library-box-active' : ''">
        <library/>
      </div>
      <img src="https://files.wondercv.com/PC/editor/jingliku.png" alt="" class="library-icon">
      <div class="library-text">经历库</div>
     <div class="img-code">
       <img src="https://files.wondercv.com/pc/code/editor_download.png" alt="">
       <span class="title">超级简历 APP</span>
       <span class="subtitle">扫码下载APP，随时随地改简历</span>
     </div> -->
		 <union-members-popup
		 	v-if="!isMentorCv"
		 	class="editor-members-popup"
      icon="https://logo.wondercv.com/banners/9jrNg081Eo2dsOZ.png"
			text="联合会员"
      storageKey="unionMemberTipsEditor"
    ></union-members-popup>
		<div class="phone-code" id="phone-code" :style="{visibility: loadExperience ? 'visible' : 'hidden'}" @click.stop="changeLibraryState" v-if="!isMentorCv">
      <div class="library-box" :class="libraryState ? 'library-box-active' : ''" :style="{'right': this.libraryPositionRight, 'height': `calc(100vh - ${libraryPositionTop}px)`}">
        <library />
      </div>
      <img src="https://files.wondercv.com/PC/editor/jingliku.png" alt="" class="library-icon">
      <div
				class="library-text"
				:style="{color: personInfo && personInfo.theme === 'light' ? '#404040' : ''}"
			>经历库</div>
    </div>
    <!-- 大图预览组件 -->
    <showResume :show="show" @close="show = false"/>
    <download-app class="download-app-chat" :dialog-state="downloadAppState" :dialog-data="dialogData" @handleClose="changeDownloadAppState" />
    <download-app-by-resume class="download-app-chat" :dialog-state="downloadAppResumeState"
                            @handleClose="changeDownloadAppResume" />
    <w-confirm class="confirm-content" top="25" :dialog-state="confirmState" :dialog-content-data="dialogContentData" :options="dialogOptions" @handleClose="confirmState = false" />
    <!-- 右侧菜单及右侧模块 -->

    <!-- 上传简历头像 组件 -->
    <transition name="opacity">
      <comp-portrait v-if="portraitDialogVisible" />
    </transition>

<!--		<purchases-error-number :personInfo="personInfo" v-if="showPurchasesErrorNumber"/>-->
    <pay-alert v-if="showPurchasesErrorNumber" @close="setShowPurchasesErrorNumber(false)"/>



		<!-- nps -->
    <nps v-on:showNps="showNps" :isShow="npsFlag" :token="token" v-if="showNpsFlag"/>
		<!-- 小助手-欢迎词 -->
		<div class="helper-welcome-popup helper-popup-visibility" :class="[editorHelperPopup.showWelcome ? 'visibility' : '']" :data-gio-imp-track="`pc-editor-helper-welcome-${editorHelperPopup.leaveDay <= 1 ? 0 : 1}`">
			<template v-if="editorHelperPopup.leaveDay <= 1">
				<p class="popup-title f_16">欢迎来到超级简历</p>
				<p class="popup-desc">在这里迈出你的求职第一步吧~</p>
			</template>
			<template v-else>
				<p class="popup-title f_16">欢迎回到超级简历</p>
				<p class="popup-desc">你不在的 {{editorHelperPopup.leaveDay}} 天，我都在等你回来~</p>
			</template>
			<div class="iconfont iconclose" @click="closeHelperPopup({type: 'showWelcome'})"> </div>
		</div>

		<!-- 小助手-简历匹配的职位 -->
		<div class="helper-job-popup helper-popup-visibility" :class="[editorHelperPopup.showRecommendJob ? 'visibility' : '']" data-gio-imp-track="pc-editor-helper-job">
			<div class="iconfont iconclose" @click="closeHelperPopup({type: 'showRecommendJob'})"></div>
			<div  class="tip-box">
				<img src="https://files.wondercv.com/PC/editor/service/job.png"/>
				<div class="tip-text">匹配职位推荐</div>
			</div>
			<cvJobCard :cardData="editorHelperPopup.recommendJobItem" v-if="!!editorHelperPopup.recommendJobItem" />
		</div>

		<!-- 小助手-关注公众号 -->
		<div class="helper-wechat-popup helper-popup-visibility" :class="[editorHelperPopup.showBindSubscribe ? 'visibility' : '']" data-gio-imp-track="pc-editor-helper-subscribe">
			<img src="https://files.wondercv.com/PC/editor/service/weixin.png" alt="" class="icon">
			<div class="tips f_14">
				<p class="popup-title f_16">订阅微信通知</p>
				<p class="popup-desc">获取最新招聘动态</p>
			</div>
			<div class="button f_12" @click="checkBindSubscribe()">立即订阅</div>
			<div class="iconfont iconclose" @click="closeHelperPopup({type: 'showBindSubscribe'})"></div>
		</div>
		<!-- 小助手-关注公众号 -->
		<div class="helper-wechat-popup-qrcode helper-popup-visibility" :class="[showBindSubscribeQrcode ? 'visibility' : '']" data-gio-imp-track="pc-editor-helper-subscribeQrCode">
			<div class="title f_16 color_40">扫码订阅微信通知</div>
			<img :src="bindSubscribeQrcodeUrl" alt="" class="icon">
			<div class="iconfont iconclose" @click="showBindSubscribeQrcode = false; toggleUdeskBtnAction(false)"></div>
		</div>
    <NewAccountGuide :type="guideType" @closeGuide="closeGuide" v-if="!isMentorCv" />
    <div class="popup-banner-container" v-if="popupBanner.image && showPopupBanner && !currentInfo.operation">
      <img :src="popupBanner.image" alt="" @click="toBannerLink">
      <div class="close-btn" @click="showPopupBanner = false" />
    </div>
    <alert ref="recommendCvAlert" :alertData="alertData" @close="alertClose"/>
  </div>
</template>
<script>
  import { uuid } from 'vue-uuid';
	// import show from './components/resume/show';
	import resume from './components/resume/resume'
	import editModule from './components/editModule'
	import cvScanner from './components/resume/cv-scanner'
	import downloadApp from './components/downloadApp'
	import downloadAppByResume from './components/downloadAppByResume'
	// import show from "@/components/resume/show";
  // import job from '../cvsEditor/components/sidebar/job'
	import composing from '../cvsEditor/components/sidebar/composing'
	import library from '../cvsEditor/components/sidebar/library'
	import manage from '../cvsEditor/components/sidebar/manage'
	import info from './components/info/index'
	import editor from './components/editor'
	import editNav from './components/editNav'
	import skeleton from '@/components/cvs/editor/img'
	import nps from '@/components/nps'
	import sidebar from './components/sidebar/index'
  import DownResumeBox from "./components/downResumeBox"
	import api from '~/api'
	import { routerTo, isSupportFontFamily, setEditNumVuex } from '@/assets/js/util'
	import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
	import { Loading } from 'element-ui'
	import showResume from './components/resume/showResume'
	import Cookies from 'js-cookie'
	import { get_tUser } from '../../../assets/js/util'
  import WConfirm from '../../../components/base/WConfirm'
  import CompPortrait from './components/portrait'
	// import purchasesErrorNumber from './components/info/purchases-error-number'
  import payAlert from "@/views/account/user/payAlert.vue";
	import cvJobCard from './components/cvJobCard'
  import CompMenu from './components/menu'
	import UnionMembersPopup from '../../cvs/components/unionMembersPopup.vue'
  // 新用户引导组件
  import NewAccountGuide from './components/NewAccountGuide';
	import alert from '@/views/cvs/components/alert';
	import { styleMixin } from '@/assets/js/mixins';

	let ossTimeName = null //oss定时器
	let robotTimer = null
	const MAX_WIDTH = 720
	// const MIN_WIDTH = 415
	const MIN_WIDTH = 570
	export default {
		mixins: [styleMixin],
		name: 'cvsEditorMain',
		layout: 'notTop',
		components: {
			// show,
			showResume,
			resume,
			info,
			// editor,
			editNav,
			// skeleton,
			nps,
			// sidebar,
			editModule,
			cvScanner,
			downloadApp,
			downloadAppByResume,
      // job,
			composing,
			library,
			manage,
      WConfirm,
      DownResumeBox,
      CompPortrait, // 上传简历头像组件
			// purchasesErrorNumber, //购买纠错次数弹窗
			cvJobCard,
      CompMenu, // 顶部操作栏
      NewAccountGuide,
      payAlert,
      alert,
			UnionMembersPopup
		},
		data () {
			return {
				// 屏幕宽高
				baseWidth: 0,
				width: 0,
				height: 0,
				margin: 'auto',
				zoom: 1, // 简历缩放
				show: false, // 是否展示预览大图
				showSkeleton: false,
				infoItem: 0, // 左侧选项卡
				page: 1, // 当前页码
				pages: 1, // 总页数
				faqOptions: [], // 贴士select
				faqs: {}, // 贴士data
				faqActive: '', // 选中贴士
				editData: {},
				// 案例
				exampleOptions: [], //案例left select
				exampleOptionsActive: '',
				exampleTags: [], // 案例right select
				exampleTagsActive: '',
				examples: [], // 案例内容
				resumeSkeleton: true,
				editSkeleton: true,
				infoSkeleton: false,
				path: '',
				token: '',
				npsFlag: false, // 展示nps
				user_id: '',
				on_off: true,//是否展开
				isResize: false,//是否处于修改屏幕大小中
				cvsWidth: 570,
				scale: 1,
				userCount: 0, // 同时在线人数
				isLight: false,
				timer: null,
				currentPage: 1, // 当前页码
				scrollY: 0, // 简历滚动时候上方的距离
				scrollTimer: null,
				showPagination: false, // 是否显示页码
				onePageState: false, // 智能一页是否显示
				downloadAppState: false, // 引导下载App的弹窗
				downloadAppResumeState: false,
				currentSidebarOption: 'check',
				banner:'',
        dialogData: {
					title: '打开APP 参与讨论',
          subTitle: '手机随时编辑简历，讨论求职问题',
          description: '扫码下载APP  发布分享与求助',
	        imgUrl: 'https://files.wondercv.com/download-code/editor-check.png'
        },
        confirmState: false,
        dialogContentData: {
				  title: '简历优先推荐中',
          content: '大厂已入驻超级简历，简历会被优先推荐给匹配职位<br />你可以在隐私设置中屏蔽不感兴趣公司',
          confirmText: '立即开启',
          cancelText: '设置',
          confirmFn: () => {
            // this.confirmState = false
            this.setPersonPrivacy()
					},
          // cancelText: '完善简历',
          cancelFn: () => {
            routerTo('/account/users?index=2', '_blank')
          },
          isSetOnlineCv: true
        },
				dialogOptions: {
					showCloseIcon: true
				},
        resumeCommentsNum: 0,
				cvEncodedToken: '',
        switchOption: {
          recommend_for_hr: false,   // 对企业HR推荐
          recommend_for_classmate: false, // 对校友/前同事推荐
          recommend_for_internal: false,   // 对有内推资源者推荐
          increase_exposure: false, // 加强曝光
          contact_directly: false,   // 	直接联系
          // contact_insite: false   // 站内联系
        },   // 隐私设置
        _c_t: '',   // cv_account_token
				showBindSubscribeQrcode: false, //是否显示绑定公众号的二维码
				bindSubscribeQrcodeUrl: '', //绑定微信的二维码
        resumeW: 0,
        downResumeBoxDom: null,   // 下载简历容器的 dom
        libraryTipDom: null,   // 右下角经历库 Icon 的 dom
        editorMenuDom: null,   // editor 顶部的工具栏 dom
        libraryPositionRight: 0,   // 经历库定位
        libraryPositionTop: 0,    // 经历库定位
        guideType: '',   // 新用户引导类型
        loadExperience: false,  // 经历库数据加载完成
        downloadAppDialogVisible: false,
				alertData: {
					show: false,
					type: ''
				},
				popupBanner: {},     // 浮窗 banner 数据
				showPopupBanner: true,    // 浮窗 banner 显示开关
			}
		},
		computed: {
			...mapState('cvsEditor', [ 'cvInfo', 'mentor' ]),
			...mapState('cvs', [ 'cvs', 'cv', 'cvPages', 'downloadCv', 'check', 'isAutoOnePage', 'autoOnePage', 'section_titles' ]),
			...mapState('experience', [ 'sidebarOption', 'userFontFamily' ]),
			...mapState('editor', [ 'portraitDialogVisible', 'cvToken', 'cvDetail', 'currentInfo', 'resumeWidth', 'isUnfold', 'onePageFunction', 'autoOnePage', 'editNumber', 'showScanner', 'syncSuccess', 'wordCount', 'isShowDownloadResume', 'emitShowDownloadResumeBox', 'showPurchasesErrorNumber', 'openResumeError', 'editorHelperPopup', 'libraryState', 'emitShowLibrary', 'isMyselfResume', 'isMentorCv']),
			...mapState('global', [ 'nonChrome' ]),
			...mapState('me', [ 'personInfo' ]),
			...mapGetters('experience', [ 'experienceListLength' ]),
			...mapGetters('editor', [ 'getCvDetailModelLength' ]),

			isMentorEditor () {
				return window.location.href.includes('mentor')
			},
			// 判断是否显示npsFlag
			showNpsFlag(){
				// 模块>=3 && 没有提交过nps && 没有显示绑定微信弹窗 && 没有显示推荐职位卡片
				return this.experienceListLength >= 3 && this.npsFlag && !this.editorHelperPopup.showBindSubscribe && !this.editorHelperPopup.showRecommendJob
			},
		},
		watch: {
      libraryState: {
        handler(val) {
          if (val) {
            setTimeout(() => {
              this.computedLibraryRight()
            },500)
          }
        }
      },
			cv: {
				deep: true,
				immediate: true,
				handler: function (cv) {
					// if (!cv && !cv.base) return false;
					this.$nextTick(() => {
						setTimeout(() => {
							// this.editSkeleton = false
							this.infoSkeleton = false
							this.showSkeleton = true
							let loadingInstance = Loading.service({ text: '加载中...' })
							this.$nextTick(() => {
								// 以服务的方式调用的 Loading 需要异步关闭
								loadingInstance && loadingInstance.close()
							})
						}, 500)
					})
				}
			},
			resumeWidth () {
				this.resetResume()
			},
			sidebarOption (value) {
				//比较宽度是否缩放
				//右侧菜单右边据最右侧的距离
				// 328 414
				let sidebarLeft = document.body.offsetWidth - 414 - 68
				//显示在屏幕的编辑区域和简历预览（两个模块resumeWidth，三个16的边距）
				let cvs_edit_margin = this.resumeWidth * 2 + 48
				if (value) {
					// if (value === 'library') {
					document.querySelector('.edit-cv-main').style.width = 'calc(100vw - 108px)'
					document.querySelector('.edit-cv-main').style.minWidth = '1172px'
					// this.setResumeWidthByValue(((document.body.offsetWidth - 590 - 16) / 2) > MAX_WIDTH ? MAX_WIDTH : Math.max(...[ ((document.body.offsetWidth - 590 - 16) / 2), 415 ]))
					this.calcResumeWidth()
					setTimeout(() => {
						this.resetResume()
					}, 0)
					// if (sidebarLeft < 870) {
					// 	this.scale = (415 - (870 - sidebarLeft)) / 415
					// 	this.$nextTick(() => {
					// 		this.resetResume()
					// 	})
					// } else {
					// 	setTimeout(() => {
					// 		this.resetResume()
					// 	}, 0)
					// }
					// } else {
					// 	document.querySelector('.edit-cv-main').style.width = 'calc(100vw - 504px)'
					// 	document.querySelector('.edit-cv-main').style.minWidth = '830px'
					// 	// this.setResumeWidthByValue(((document.body.offsetWidth - 504 - 16) / 2) > MAX_WIDTH ? MAX_WIDTH : Math.max(...[ ((document.body.offsetWidth - 504 - 16) / 2), 415 ]))
					// 	this.calcResumeWidth()
					// 	if ((sidebarLeft + 68) < 870) {
					// 		this.scale = (415 - (870 - sidebarLeft - 68)) / 415
					// 		this.$nextTick(() => {
					// 			this.resetResume()
					// 		})
					// 	} else {
					// 		this.scale = 1
					// 		this.$nextTick(() => {
					// 			this.resetResume()
					// 		})
					// 	}
					// }
				} else if (!this.currentInfo.operation) {
					if (this.scale != 1) {
						this.scale = 1
					}
					document.querySelector('.edit-cv-main').style.width = 'calc(100vw - 108px)'
					document.querySelector('.edit-cv-main').style.minWidth = '1172px'
					// this.setResumeWidthByValue(((document.body.offsetWidth - 464) / 2) > MAX_WIDTH ? MAX_WIDTH : (((document.body.offsetWidth - 464) / 2) < 415 ? 415 : ((document.body.offsetWidth - 464) / 2)))
					this.$nextTick(() => {
						this.calcResumeWidth()
						this.resetResume()
					})
				}
			},
      'currentInfo.type' (val) {
        this.updateLibraryState(false)
				this.setOptimizationData({
					status: 'initial',
					result: ''
				})
	      if (!val) {
	        if(this.emitShowDownloadResumeBox){
            this.updateLibraryState(false)
            this.emitShowDownBox(false)
            this.setIsShowDownloadResume(true)
          }
          if (this.emitShowLibrary) {
            setTimeout(() => {
              this.changeLibraryState()
            }, 1000)
            this.setEmitShowLibrary(false)
          }
		      this.setAssistInfo({ type: 'faqs', info: { faqs: [] } })
		      this.setAssistInfo({ type: 'verbs', info: { verbs: [] } })
		      this.setAssistInfo({
			      type: 'examples',
			      info: {
				      examples: [],
				      example_options: [],
				      example_tags: []
			      }
		      })
	      } else if (val) {
	        this.setIsShowDownloadResume(false)
		      if (this.currentInfo.type !== 'extras') {
			      this._getAssistInfo('examples')
			      this._getAssistInfo('verbs')
		      }
		      this._getAssistInfo('faqs')
	      }
      },
			'currentInfo.operation' (val) {
				if (val) {
					this.currentSidebarOption = this.sidebarOption
					this.updateSidebarOption('')
        } else {
					this.setOptimizationData({
						status: 'initial',
						result: ''
					})
					this.updateSidebarOption('check')
				}
				document.querySelector('.edit-cv-main').style.width = 'calc(100vw - 108px)'
				document.querySelector('.edit-cv-main').style.minWidth = '1172px'
				this.$nextTick(() => {
					setTimeout(() => {
						this.calcResumeWidth()
						this.resetResume()
					}, 150)
				})
			},
      syncSuccess(value) {
			  if (value) {
			    this.getPersonPrivacy()
			    this.confirmState = true
        }
      },
			scrollY (val) {
				if (this.scrollTimer) {
					this.showPagination = true
					clearTimeout(this.scrollTimer)
				}
				this.scrollTimer = setTimeout(() => {
					this.showPagination = false
				}, 500)
			},
			// 判断是否切换小助手打开样式
			showNpsFlag(val){
				if(val){
					this.toggleUdeskBtnAction(true)
					this.setEditorHelperPopup({
						...this.editorHelperPopup,
						npsFlag: true,
						local: true,
					});
				}
			},
			// 判断是否弹出小助手欢迎语
			'cvDetail.basic_info': {
				deep: true,
				immediate: true,
				handler: function (basic_info) {
					let leaveDay = (new Date().getTime() - new Date(basic_info.updated_at).getTime()) /1000/60/60/24
					if(!this.editorHelperPopup.showWelcome && (basic_info.kind || leaveDay > 99)){
						let localData = localStorage.getItem(`${this._c_t}_helper_popup`) || "{}"
						localData = JSON.parse(localData)
						if(!localData.showWelcome){
							this.setEditorHelperPopup({
								...this.editorHelperPopup,
								showWelcome: true,
								leaveDay: basic_info.kind ? 0 : Math.round(leaveDay), //距离上次登录时间（天）
								local: true,
							})
							setTimeout(() => {
								// 关闭提示框
								this.closeHelperPopup({
									type: 'showWelcome'
								})
							}, 1000 * 10);
						}
					}
				},
			}
		},
		beforeCreate () {
			Loading.service({ text: '加载中...' })
			this.$store.commit('editor/setResumeWidth', { value: document.body.offsetWidth, type: 'new' })
		},
		async created () {
      document.addEventListener('click', () => {
        this.downloadAppDialogVisible = false
      })
      // 获取当前简历是否有 jobscan 报告
      // this.getReport()
			setEditNumVuex()
			this.handleScroll = this.throttle(this.handleResumeScroll, 150)
			this.getOnlineUserCount()
			this.setIsUnfold(localStorage.getItem('on_off'))
			let { path, params } = this.$route
			let { token } = params
			this.path = path
			this.token = token
			// 新逻辑
			// 设置token
			// this.$store.commit('cvsEditor/setCvToken', this.token)
			// 获取页面数据
			// this.$store.dispatch('cvsEditor/getProfile', this.token)
			//初始化页面
			this.getCvsList()
			//初始化oss配置
			this.initOssBease()
			//检测是否显示过nps
      this.getCvSectionTitle()
	  	this.getBanner()
      this.getPopupBanner()
			// if (res && res.status !== 1 && res.code === 2004) {
			//   this.$message.error("此页面已加密，请登录后尝试");
			//   setTimeout(() => {
			//     routerTo("/signin?type=login");
			//   }, 500);
			//   return false;
			// } else if (!res || res.status !== 1) {
			//   this.$message.error("此页面已加密，您没有访问权限");
			//   setTimeout(() => {
			//     routerTo("/cvs");
			//   }, 500);
			//   return false;
			// }
      this.$eventBus.$on('saveEditorModule', async (moduleType) => {
				console.log('moduleType=>>>', moduleType)
        if(this.isMentorEditor) return;
				let localData = localStorage.getItem(`${this._c_t}_helper_popup`) || "{}"
				localData = JSON.parse(localData)
				let { kind } = this.cvDetail.basic_info
				// console.log('this.editorHelperPopup=>>>',this.editorHelperPopup)
				// console.log('localData=>>>',localData)
				// console.log('准备判断 职位卡片', (moduleType === 'works' && !kind && !this.editorHelperPopup.showRecommendJob && !localData.showRecommendJob && !this.editorHelperPopup.showBindSubscribe && !this.showNpsFlag) )

				// 判断是否展示小助手-职位卡片 没有弹出过绑定公众号卡片 && 不是模版 && 没有nps
				if(moduleType === 'works' && !kind && !this.editorHelperPopup.showRecommendJob && !localData.showRecommendJob && !this.editorHelperPopup.showBindSubscribe && !this.showNpsFlag){
					this.setEditorHelperPopup({
						...this.editorHelperPopup,
						showRecommendJob: true,
						local: true,
					});
					return false
				}
				// console.log('准备判断 绑定公众号', (this.getCvDetailModelLength >= 4 && !kind && !this.editorHelperPopup.showRecommendJob && !this.editorHelperPopup.showBindSubscribe && !localData.showBindSubscribe && !this.showNpsFlag) )
				// 判断是否展示小助手-绑定公众号 4个模块有内容 && 不是模版 && 没有弹出过绑定公众号卡片 && 没有弹出职位卡片 && 没有nps
				if(this.getCvDetailModelLength >= 4 && !kind && !this.editorHelperPopup.showRecommendJob && !this.editorHelperPopup.showBindSubscribe && !localData.showBindSubscribe && !this.showNpsFlag){
					this.setEditorHelperPopup({
						...this.editorHelperPopup,
						showBindSubscribe: true,
						local: true,
					});
					return false
				}
				// console.log('准备判断 nps', (!this.editorHelperPopup.showBindSubscribe && !kind && !this.editorHelperPopup.showRecommendJob) )
				// 判断是否展示小助手-nps 没有弹出过绑定公众号卡片 && 不是模版 && 没有弹出职位卡片
				if(!this.editorHelperPopup.showBindSubscribe && !kind && !this.editorHelperPopup.showRecommendJob){
					// 消息订阅卡片
					await this.isShowNps()
				}
      })
      await this.getDaniuTabs()
      await this.initPageData()
		},
		async mounted () {
			// this.handleCheckUserLock()
      this.downResumeBoxDom = document.getElementById('down-resume-box')
      this.libraryTipDom = document.getElementById('phone-code')
      this.editorMenuDom = document.getElementById('editor-menu')
			this.baseWidth = window.innerWidth;
			let _t = Cookies.get('_t')
			if (!_t) {
				routerTo('/auth-signin/?type=login')
			}
			// 所有方法走mounted 方法
			// 监测屏幕大小
			// this.setResumeWidthByValue(((document.body.offsetWidth - 464) / 2) > MAX_WIDTH ? MAX_WIDTH : (((document.body.offsetWidth - 464) / 2) < 415 ? 415 : ((document.body.offsetWidth - 464) / 2)))
			this.calcResumeWidth()
			let debounce = (func, delay) => {
				let timeout
				return (e) => {
					clearTimeout(timeout)
					timeout = setTimeout(() => {
						func()
					}, delay)
				}
			}
			let validate = debounce(event => {
				let num = (document.body.offsetWidth - 464) / 2
				let sidebarLeft = document.body.offsetWidth - 414 - 68
				if (!this.isUnfold && this.currentInfo.operation) {
					// this.setResumeWidthByValue(MAX_WIDTH)
					this.calcResumeWidth()
				} else {
					// if (this.sidebarOption) {
					// 	document.querySelector('.edit-cv-main').style.width = 'calc(100vw - 590px)'
					// 	document.querySelector('.edit-cv-main').style.minWidth = '830px'
					// 	this.calcResumeWidth()
					// } else {
					document.querySelector('.edit-cv-main').style.width = 'calc(100vw - 108px)'
					document.querySelector('.edit-cv-main').style.minWidth = '1172px'
					this.calcResumeWidth()
					// }
				}
				setTimeout(() => {
					this.resetResume()
				}, 0)
        setTimeout(() => {
          this.computedLibraryRight(true)
        },500)
				this.isResize = false
			}, 500)
			window.addEventListener('resize', () => {
				this.isResize = true
				validate()
				this.calcPageScale()
			})

			//添加修改udesk_btn样式
			document.getElementsByTagName('body')[0].className += ' editor_udesk_btn'

			//暂时放到宏任务队列。不然渲染异常
			setTimeout(() => {
				// this._initDomSite(true)
				this.resetResume()
			}, 1000)
      //获取批注的数量
      this.getResumeCommentsNum()
      // this.confirmState = true
			this._c_t = get_tUser().c_t || ''
      // this.getPersonPrivacy()

			
			//editor广告页弹框
			let cvsba=localStorage.getItem("cv_editor_banner")
			let isshowcvsbanner = true;
			if(cvsba){
				if(new Date().toLocaleDateString() == cvsba){
					isshowcvsbanner = false;
				}else{
					isshowcvsbanner = true;
				}
			}
			if(isshowcvsbanner==true){
				let res = await api.jobs.getBanner({position: '127'})
				if(res.code == 1000) {
					this.alertData = {
						show: true,
						type: 'cvsguanggao',
						image: res.data[0],
					}
					if (res.data[0]){
						localStorage.setItem("cv_editor_banner",new Date().toLocaleDateString())
          }

				}
				console.log(res)
			}

			robotTimer = setTimeout(() => {
				const el = document.querySelector('#udesk_btn a');
				const color = this.personInfo.theme === 'light' ? '#404040' : '#fff';
				if (el) {
					el.style.color = color;
				}
			}, 300)
		},
		beforeDestroy () {
			//清除定时器
			clearInterval(ossTimeName)
			clearTimeout(robotTimer)
			//清除-修改udesk_btn样式
			var classVal = document.getElementsByTagName('body')[0].getAttribute('class')
			classVal = classVal.replace('editor_udesk_btn', '')
			document.getElementsByTagName('body')[0].setAttribute('class', classVal)
		},
		methods: {
      ...mapActions('cvsEditor', [ 'getCvInfo', ]),
      ...mapActions('cvs', [ 'getCvSectionTitle', ]),
			...mapActions('editor', [ 'getCvDetail', 'getCvInfoData', 'getCheckData', 'getAssistInfo' ]),
			...mapActions('experience', [ 'getExperienceList', 'getDaniuTabs', 'getDaniuExperienceList' ]),
			...mapActions('manage', [ 'getMenuList', ]),
			...mapActions('global', [ 'getOssBeaseOptions', ]),
			...mapMutations('editor', [ 'setJobscanResultData', 'setIsShowJobscanGuide', 'setHasJobscanRepor', 'setMentorCv', 'setResumeWidth', 'setIsUnfold', 'setResumeWidthByValue', 'setCvDetail', 'setBackUpFormatInfo', 'setAssistInfo', 'setIsShowDownloadResume', 'emitShowDownBox', 'setEditorHelperPopup', 'updateMyselfResumeState', 'updateLibraryState', 'setQuitResumeEditor', 'setCheckCloseEditModule', 'setEmitShowLibrary', 'setShowPurchasesErrorNumber', 'setOptimizationData' ]),
			...mapMutations('experience', [ 'initUserFontFamily', 'updateSidebarOption', 'updateCvDetail' ]),
			...mapMutations('me', { setPersonInfo: 'GET_INFO' }),
			...mapActions('cv', ['getCvsList']),
			async handleCheckUserLock() {
				try {
					const res = await api.account.getCip();
    			if (res.code === 1000 && res.data.internal) return '内网环境';

					const { code } = await api.account.checkUserLock()
					if (code === 2003) {
						window.location.href = '/cvs'
					}
				} catch (error) {
					console.log(error)
				}
			},
			alertClose() {
				this.alertData.show = false;
				this.updateLoading = false
				setTimeout(async () => {
					await this.getData('second');
					// this.getRecommendList()
				}, 100);
			},
			async getPopupBanner() {
				Promise.all([api.jobs.getBanner({position: '128'})])
					.then(([popupRes]) => {
						if (popupRes.code === 1000 && popupRes.data.length) {
							console.log(popupRes, "==================>lalalaala")
							this.popupBanner = popupRes.data[0] || {};
						}
					})
			},
			toBannerLink() {
				if (!this.popupBanner.image || !this.popupBanner.link) return
				window.open(this.popupBanner.link)
			},
      resumeWidthFun (w) {
        if (!w) return false
        this.resumeW = w
      },
      // 关闭新用户引导
      closeGuide() {
        this.guideType = ''
      },
      // 关闭右侧内容（下载简历/经历库）
      closeRightContent() {
        this.setIsShowDownloadResume(false)
        this.updateLibraryState(false)
      },
      // 切换经历库显示状态
      changeLibraryState(autoOpen) {
        // 自动打开时检测到已经是打开状态直接返回（已经打开的经历不执行自动打开逻辑）
        if (typeof autoOpen !== 'object' && this.libraryState) return
        if (this.libraryState) {
          this.updateLibraryState(false)
        } else {
          this.computedLibraryRight()
          if (this.currentInfo.operation) {
            //设置是否需要取消当前编辑状态，并返回
            this.setCheckCloseEditModule(true)
            this.setEmitShowLibrary(true)
          } else {
            this.openLibrary()
          }
        }
      },
      // 计算经历库位置
      computedLibraryRight(resize) {
        // 不需要重新计算的直接返回
        if ((this.libraryPositionTop && this.libraryPositionRight) && !resize) return
        let downResumeBoxPosition = {}
        let libraryTipPosition = {}
        let editorMenuPosition = {}
        // 获取下载简历的容器位置
        if (this.downResumeBoxDom) {
          downResumeBoxPosition = this.downResumeBoxDom.getBoundingClientRect()
        } else {
          downResumeBoxPosition = document.getElementById('down-resume-box').getBoundingClientRect()
        }
        // 获取右下角经历库 Icon 的位置
        if (this.libraryTipDom) {
          libraryTipPosition = this.libraryTipDom.getBoundingClientRect()
        } else {
          libraryTipPosition = document.getElementById('phone-code').getBoundingClientRect()
        }
        // 获取 editor 顶部工具栏的位置
        if (this.editorMenuDom) {
          editorMenuPosition = this.editorMenuDom.getBoundingClientRect()
        } else {
          editorMenuPosition = document.getElementById('editorMenu').getBoundingClientRect()
        }
        // 计算经历库距离顶部位置
        this.libraryPositionTop = editorMenuPosition.top
        // 计算经历库定位位置
        this.libraryPositionRight = libraryTipPosition.right - downResumeBoxPosition.right - (this.isShowDownloadResume ? 0 : 16) - (resize ? - 20 : 0) + 'px'
      },
      // 关闭右侧下载，打开经历库
      openLibrary() {
        this.setIsShowDownloadResume(false)
        this.updateLibraryState(true)
      },
      // 这个简历是否有 jobscan 报告
      async getReport(){
        try {
          let res = await api.jobs.getBriefReport({cv_token:this.$route.params.token})
          if(res.code === 1000){
            this.setIsShowJobscanGuide(false)
            this.setHasJobscanRepor(true)
            this.setJobscanResultData(res.data)
          }else{
            this.setHasJobscanRepor(false)
          }
        }catch (e) {
          console.error("获取简易报告异常",e)
        }
      },
      async getPersonPrivacy() {
        try {
          let res = await api.account.getPersonPrivacy(this._c_t);
          if (res.code === 1000) {
            this.switchOption = res.data
          } else {
            this.$message.error(res.message);
          }
        } catch (e) {
          console.error(e);
        }
      },
      // 设置隐私设置
      async setPersonPrivacy() {
        try {
          this.switchOption.contact_directly = true
          let res = await api.account.setPersonPrivacy(this._c_t, this.switchOption);
          if (res.code === 1000) {
            // this.switchOption = res.data
            this.$message.success('开启成功')
            this.confirmState = false
          } else {
            this.$message.error(res.message);
          }
        } catch (e) {
          console.error(e);
        }
      },
			// 客服位置
			_initDomSite (needTimer) {
				this.$nextTick(() => {
					let menuEl = document.querySelector('.menu-content')
					let left = menuEl ? menuEl.getBoundingClientRect().left : 0
					let themeEl = document.querySelector('.change-theme')
					themeEl.style.left = `${ left + 14 }px`
					if (needTimer) {
						setTimeout(() => {
							let UDeskDom = document.querySelector('#udesk_btn')
							if (UDeskDom) UDeskDom.firstChild.style.left = `${ left }px`
						}, 1500)
					} else {
						let UDeskDom = document.querySelector('#udesk_btn')
						if (UDeskDom) UDeskDom.firstChild.style.left = `${ left }px`
					}
				})
			},
			// 在简历上切换模块的时候，弹窗上面显示保存
			saveFormData () {
				this.$refs.editModuleForm.saveModuleData()
			},
			// 更改下载简历弹窗的状态
			changeDownloadAppResume () {
				this.downloadAppResumeState = !this.downloadAppResumeState
			},
			// 点击下载App弹窗
			changeDownloadAppState () {
				this.downloadAppState = !this.downloadAppState
			},
			// 智能一页的鼠标移入 移出事件
			onMouseOver () {
				this.onePageState = true
			},
			onMouseLeave () {
				this.onePageState = false
			},
			_getAssistInfo (content) {
				let fields = [ 'works', 'orgs', 'edus', 'opus' ,'extras' ]
				let { type } = this.currentInfo
				let { basic_info: { cv_type } } = this.cvDetail
				let payload = {
					cv_type,
					type: content
				}
				if (fields.includes(type)) {
					payload.submodule_type = type
				} else if (!type) {
					payload.submodule_type = 'extras'
				} else {
					payload.submodule_type = 'custom_sections'
					payload.custom_section_category = typeof type === 'number' ? 'custom' : type
				}
				this.getAssistInfo({ payload, type: content })
			},
			handleScroll () {
			},
			// 监听简历的滚动事件
			handleResumeScroll () {
				this.throttle(() => {
					const resumeEl = document.querySelector('.cvs-component')
					const resumeHeight = document.querySelector('.resume').clientHeight
					const screenHeight = document.body.clientHeight
					this.scrollY = resumeEl.scrollTop
					for (let i = this.pages; i > 0; i--) {
						let elString = `.page-index-${ i }`
						let el = document.querySelector(elString)
						if(!el){
							break
						}
						// 第几页的dom元素距离浏览器顶部的高度 减去 简历距离浏览器顶部的位置 为 第i页距离简历顶部的高度
						let pageIndexHeight = el.getBoundingClientRect().top - resumeEl.getBoundingClientRect().top
						let height = Math.min(resumeHeight, screenHeight - resumeEl.getBoundingClientRect().top)
						if (pageIndexHeight < height) {
							this.currentPage = i
							break
						}
					}
				}, 30)()
			},
			// 处理点击 check 时的dom滚动问题
			dealCheckDomScroll ({ pageIndex, pageElHeight }) {
				// this.page = pageIndex
			},
			// 计算屏幕大小，设置当前简历的宽度
			calcResumeWidth () {
				const bodyWidth = document.body.offsetWidth
				const el = document.querySelector('.edit')
				const { operation } = this.currentInfo
				let resumeWidth = 0
				let surplus = 0
				if (this.sidebarOption) {
					const sideBarWidth = this.sidebarOption === 'library' ? 414 : 324
					// surplus = this.sidebarOption === 'library' ? bodyWidth - 924 : bodyWidth - 838
					surplus = bodyWidth - sideBarWidth - 68 - 120 - 16
				} else {
					// this.isUnfold && el ? bodyWidth - el.offsetWidth - 364 - 16 - 68 :
					surplus = el ? bodyWidth - el.offsetWidth - 68 - 120 - 16 - 16 : bodyWidth - 364
				}
				resumeWidth = surplus > MAX_WIDTH ? MAX_WIDTH : surplus < MIN_WIDTH ? MIN_WIDTH : Math.max(...[ surplus, MIN_WIDTH ])
				this.setResumeWidthByValue(resumeWidth)
				// this._initDomSite()
			},
			// 更换简历主题
			changeEditorTheme () {
				this.debounce(async () => {
					let info = JSON.parse(JSON.stringify(this.personInfo))
					if (info.theme === 'light') {
						info.theme = 'dark'
					} else {
						info.theme = 'light'
					}
					let { c_t } = get_tUser()
					let res = await api.cvsEditor.changeEditorTheme(c_t, { theme: info.theme })
					if (res.code === 1000) {
						this.setPersonInfo(info)
					} else {
						this.$message.error('请重试')
					}
				}, 200)
			},
			// 获取同时在线人数
			async getOnlineUserCount () {
				try {
					let res = await api.cvsEditor.getOnlineUserCount()
					if (res.code === 1000) {
						this.userCount = res.data.online_user_count
					}
				} catch (e) {
					console.log(e)
				}
			},
			//获取banner
			async getBanner() {
			// banner
			try {
				let res = await api.jobs.getBanner({position: '73'});
				if (res.code === 1000) {
				this.banner = res.data[0];
				}

			} catch (e) {
				console.log(e)
			}
			},
			async toLink() {
				if(!this.banner.link) return
				window.open(this.banner.link,"_blank")
			},
			// 防抖函数
			debounce (fn, timeInterval) {
				if (this.timer) {
					clearTimeout(this.timer)
				}
				let arg = [ ...arguments ].filter((item, index) => {
					return index > 1
				})
				this.timer = setTimeout(() => {
					fn.apply(this, arg)
				}, timeInterval)
			},
			// 函数节流
			throttle (fn, gapTime) {
				let _lastTime = null
				return function () {
					let _nowTime = +new Date()
					if (_nowTime - _lastTime > gapTime || !_lastTime) {
						fn()
						_lastTime = _nowTime
					}
				}
			},
			//收起展开侧边案例
			handleClickOnOff (value) {
				this.setIsUnfold(value)
				document.querySelector('.edit-cv-main').style.width = 'calc(100vw - 108px)'
				document.querySelector('.edit-cv-main').style.minWidth = '1172px'
				this.$nextTick(() => {
					this.calcResumeWidth()
					this.resetResume()
				})
			},
			async initPageData () {
				let { token } = this.$route.params
				//获取当前基础数据
				try {
          // 是否是导师打开的简历编辑页
					if (this.$route.path.includes('mentor')) {
						this.setMentorCv(true)
					}
					let cvDetailRes = await this.getCvDetail({token, cv_account_token: get_tUser().c_t || ''})
					if (cvDetailRes.code === 1000) {
						let { basic_info: { mentor_id, lang, kind }, format_info } = this.cvDetail
						if (mentor_id) this.$refs.sideBar.coachOption = 0
            // 更新是否是自己的简历（不是模板和大牛简历）
            if (kind && kind !== "jobscan") {
              this.updateMyselfResumeState(false)
            } else {
              this.updateMyselfResumeState(true)
            }
						//经历库
						this.getExperienceList(cvDetailRes.data)
            this.getDaniuExperienceList(cvDetailRes.data)
						//获取已选择模块
						this.getMenuList(cvDetailRes.data)
						// 各个模块的数据
						await this.getCvInfoData({ check: true, only_desc: true })
						this.editSkeleton = false
						this.resumeSkeleton = false
						// 检测英文简历是否使用中文字体
						let cnFontList = [ 'font-1', 'font-2', 'font-3' ]
						let fontError = cnFontList.includes(format_info.font)
						if (kind !== 'template' && kind !== 'sample' && lang === 'en' && fontError) {
							let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
							cvDetail.format_info.font = 'font-4'
							//同步到vuex中
							this.setCvDetail(cvDetail)
							//触发保存
							this.updatedFormatInfo(cvDetail.format_info)
						}
						//检测当前系统是否包含字体
						this.checkFontFamily()
            this.loadExperience = true
            setTimeout(() => {
              let newLibraryGuide = localStorage.getItem("newLibraryGuide")
              // 经历库有经历 && 不是我的简历（模板/大牛简历）打开经历库
              if (this.experienceListLength && !this.isMyselfResume) {
                setTimeout(() => {
                  this.changeLibraryState(true)
                }, 1000)
                // 经历库有经历 && 在编辑我自己的简历（打开新用户引导--只出现一次）
              } else if (this.experienceListLength && this.isMyselfResume && !newLibraryGuide) {
                this.guideType = 'library'
                localStorage.setItem("newLibraryGuide", 'true')
              }
            },500)

					} else if (cvDetailRes.code === 80120 || cvDetailRes.code === 80121) {
						this.$message.error(cvDetailRes.message)
						setTimeout(() => {
							window.location.href = `${ window.location.origin }/cvs`
						}, 500)
					} else {
						this.$message.error(cvDetailRes.message)
					}
				} catch (error) {
					console.log(error)
				}
			},
			//初始化oss配置
			initOssBease () {
				this.getOssBeaseOptions()
				//十分钟重新获取一次
				let ossTimeIndex = 10
				ossTimeName = setInterval(() => {
					if (ossTimeIndex <= 0) {
						//清除定时器
						clearInterval(ossTimeName)
						//重新获取oss参数
						this.initOssBease()
					}
					ossTimeIndex -= 1
				}, 60000)
			},
			// editor change event
			editChange (data) {
				this.editData = data
			},
			getPages (pages) {
				this.pages = pages
				if (pages === 1) this.page = pages
			},

			// 原来老代码

			// 一页纸
			autoOne () {
				this.autoOnePage()
				// let isAutoOnePage = this.isAutoOnePage;
				// if (!isAutoOnePage) {
				//   this.autoOnePage();
				// }
				// this.$store.commit('cvs/SET_IS_AUTO_ONE_PAGE', !isAutoOnePage);
			},
			//是否展示过nps
			async isShowNps () {
				let _t = Cookies.get('_t')
				if (_t) {
					let tokenPayload = _t && JSON.parse(window.atob(_t.split('.')[1]))
					this.user_id = tokenPayload.User.c_t
				}
				let res = await api.nps.showNps({ id: this.user_id, channel: 6 })
				if (res.code === 1000) {
					this.npsFlag = res.data.is_fill
				}
				return res
			},
			mousewheel ($event) {
				$event.preventDefault()
				return false
			},
			closeResume () {
				this.showResumeEdit = false
				if (this.editData.editModuleShow) {
					return false
				}
				this.getCv(this.token)
			},
			// 页码改变
			currentChange (page) {
				this.page = page
			},
			pageChange (type, isPage) {
				if (isPage) {
					return false
				}
				if (type === 'prev') {
					this.page--
				} else if (type === 'next') {
					this.page++
				}
				let scrollEl = document.querySelector('.cvs-component')
				scrollEl.scrollTo({ top: 0 })
			},

			// 复制简历
			copy () {
			},
			// 投递
			sendCv () {
				routerTo(this.cv.send_to_email_url)
			},
			// 分享
			share () {
				let alertData = {
					show: true,
					type: 'shareCv',
					shareUrl: `${ process.env.HOST_ROOT }/cvs/${ this.cv.base.token }/share`
				}
				this.$store.dispatch('app/setAlertData', alertData)
			},
			// 下载
			download () {
				this.downloadCv()
			},
			// 关闭nps
			showNps () {
				this.npsFlag = false
				this.closeHelperPopup({
					type: 'npsFlag'
				})
			},
			handleClickOnePage () {
				this.onePageFunction(true)
			},

			resetResume () {
				// this.$refs.resume.visible = false
				this.$refs.resume && this.$refs.resume.setPageView()
			},
			//更新用户排版
			async updatedFormatInfo (format_info) {
				let data = {
					operation_type: 'update_format_info',
					format_info
				}
				let res = await api.cvsEditor.updatedCvInfo(this.cvToken, data)
				if (res.code === 1000) {
					//修改简历设置备份
					this.setBackUpFormatInfo(JSON.parse(JSON.stringify(format_info)))
				} else {
					// this.$message.success(res.message)
				}
			},
			//检测当前系统是否包含字体
			checkFontFamily () {
				let userFontFamily = JSON.parse(JSON.stringify(this.userFontFamily))
				let { lang } = this.cvDetail.basic_info
				let vipFont = ['黑体','楷体','仿宋', '宋体']
				userFontFamily[lang].forEach(sitem => {
					let hasFont = false
					if(vipFont.includes(sitem.cnName)){
						sitem.isVip = true
					}
					sitem.name.forEach(font => {
						if (isSupportFontFamily(font)) {
							hasFont = true
						}

					})
					sitem.hasFont = hasFont
				})
				console.log(111, userFontFamily)
				this.initUserFontFamily(userFontFamily)
			},
      async getResumeCommentsNum(){
        try {
          let res = await api.cvsV3.getAllCvComment(this.token)
          if(res.code === 1000){
            this.resumeCommentsNum = res.data.total_count
						if(this.resumeCommentsNum > 0){
							// 获取加密token
							this.getCvEncodedToken();
						}
          }
        }catch (e) {

        }
      },
			getCvEncodedToken(){
				let cvToken = this.$route.params.token
        api.shareCvs.getCvEncodedToken(cvToken, {
          token: cvToken,
          from_admin: false
        }).then(async res=>{
          if(res.code === 1000){
            let { encoded_token } = res.data;
            this.cvEncodedToken = encoded_token

          }
        })
			},

			// 关闭机器人提示
			closeHelperPopup(props){
				let { type} = props
				this.setEditorHelperPopup({
					 ...this.editorHelperPopup,
					[type]: false
				});
				this.toggleUdeskBtnAction(false)
			},
			// 判断是否绑定公众号
			checkBindSubscribe(){
				if(this.personInfo.subscribe){
					this.$message.success('订阅成功')
					// 关闭提示框
					this.closeHelperPopup({
						type: 'showBindSubscribe'
					})
				}else{
					this.setEditorHelperPopup({
						...this.editorHelperPopup,
						showBindSubscribe: false
					});
					// 获取绑定二维码
					this.getBindSubscribeQrcode();
					// 显示绑定二维码
					this.showBindSubscribeQrcode = true;
					this.toggleUdeskBtnAction(true)
				}
			},
			// 获取绑定二维码
			getBindSubscribeQrcode(){
				//获取二维码接口
				let query = {
					scene_str:'bind_' + uuid.v1(), //场景值 {扫码业务}+{身份} 扫码业务：login 扫码业务(string):login 例如login_动态的uuid
          account_type:'cv_account', //账户种类 hr_account 或 cv_account
          operation_type:'bind', //是	bind/login 目前只用bind逻辑
          expire_seconds:60, //二维码有效期
				}
        api.auth.getWechatsQrcode(query).then(res=>{
          if(res.code === 1000){
            this.bindSubscribeQrcodeUrl = res.data.url;
          }else{
            // this.$message.error(res.message);
          }
        })
			},
			// 是否显示udesk选中状态
			toggleUdeskBtnAction(type){
				let udeskBtn = document.querySelector('.editor_udesk_btn #udesk_btn .udesk-client-btn');
				if(udeskBtn){
					if(type){
						udeskBtn.classList.add("active")
					}else{
						udeskBtn.classList.remove("active")
					}
				}
			},
			// 计算页面缩放比例
			calcPageScale() {

				const scaleRatio = window.innerWidth / this.baseWidth;
				document.body.style.transformOrigin = '0 0'; // 设置变换原点为左上角
				document.body.style.transform = `scale(${scaleRatio})`;

			}
		}
	}
</script>
<style lang="scss" scoped>
  @import 'index';
  .back-box{
    cursor: pointer;
    .back-btn{
      width: 40px;
      height: 40px;
      background: #414653;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      &:hover{
        background-color: #2B2E38;
      }
      .iconfont{
        font-size: 16px;
        color: #898C96;
      }
    }
    .back-name{
      margin-top: 12px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 12px;
    }
  }
  .pages_image{
	width: 340px !important;
	height: 340px !important;
    cursor: pointer;
  }
	.replace-style-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;
		width: 102px;
		height: 112px;
		background-image: url('https://logo.wondercv.com/banners/rXqPaRKlat7Zh3n.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin-left: 16px;
		padding-bottom: 12px;
		box-sizing: border-box;
		.replace-btn {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 78px;
			height: 28px;
			border-radius: 100px;
			background-color: #fff;
			color: #ff6644;
			font-size: 11px;
			font-weight: bold;
			cursor: pointer;
			img {
				width: 10px;
				height: 10px;
				margin-right: 4px;
				transition: transform 0.3s;
				&.rotate {
					animation: rotate 0.3s forwards;
				}
			}
		}
	}

	@keyframes rotate {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}

	.editor-members-popup {
		::v-deep(.union-member-icon) {
			bottom: 216px;
			right: 26px;
			img {
				width: 40px;
				height: 40px;
			}
		}
	}
</style>
<style lang="scss">
  .pack-up {
    width: 38px;
    height: 116px;
    background: rgba(80, 86, 103, 1);
    border-radius: 0px 4px 4px 0px;
    opacity: 0.79;
    position: absolute;
    top: 160px;
    z-index: 10;
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i {
      margin-bottom: 6px;
      color: #fff;
    }
    .title {
      margin: 0 auto;
      width: 14px;
      /*height: 36px;*/
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 18px;
    }
    &:hover {
      opacity: 1;
    }
  }
  .edit-cv-main {
    .el-pagination {
      display: flex;
      justify-content: center;
      font-size: 14px;
      & > * {
        background: transparent !important;
      }
    }
    .el-pager {
      width: 245px;
      display: flex;
      justify-content: center;
      & > * {
        font-size: 14px !important;
        background: transparent !important;
        color: #cacaca !important;
        &.active {
          color: #606060 !important;
        }
      }
    }
  }
  .resume-review{
    width: 91px;
    height: 40px;
    background: #353944;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 20px;
    opacity: 0.8;
    position: fixed;
    bottom: 30px;
    right: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
    i{
      margin-right: 6px;
    }
  }
</style>
<style lang="scss" scoped>
  .optimize-info {
    transition: none;
  }
  .edit-cv-main {
    .edit-menu-content {
      ol,
      li {
        margin-left: 20px;
        margin-top: 8px;
      }
    }
  }
</style>
<style lang="scss">
  .edit-cv-main {
    .case {
      .case-menu-content {
        & > p {
          padding: 0;
        }
      }
    }
    .tips {
      ol {
        padding-left: 24px;
        list-style: none;
      }
    }
  }
</style>
<style lang="scss">
  // 设置此页面删除弹框按钮样式
  .cvs-edit-cancelButtonClass {
    background: #ff4f4c !important;
    color: #fff !important;
    border-color: #ff4f4c !important;
  }

  .cvs-edit-confirmButtonClass {
    background: #fff !important;
    color: #606060 !important;
    border-color: #d9d9d9 !important;
  }
  .popup-banner-container {
    position: fixed;
    bottom: 50%;
    right: 24px;
    transform: translateY(50%);
    border-radius: 7px;
    box-shadow: -2px 15px 25px 0px rgba(46, 66, 104, 0.12);
    cursor: pointer;
    //overflow: hidden;
    img {
      width: 100px;
			object-fit: contain;
    }

    .close-btn {
      width: 15px;
      height: 15px;
      position: absolute;
      top: -20px;
      right: 0px;
      background-color: rgba(0, 0, 0, .2);
      border-radius: 50%;
      transition: all .5s;

      &:hover {
        transform: rotate(180deg) scale(1.2);
      }

      &:before {
        content: '';
        display: block;
        width: 70%;
        height: 2px;
        background-color: rgba(255, 255, 255, .5);
        border-radius: 1px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }

      &:after {
        content: '';
        display: block;
        width: 2px;
        height: 70%;
        background-color: rgba(255, 255, 255, .5);
        border-radius: 1px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }
    }
  }
</style>
